import { ReactNode } from 'react'
import { Users01Icon, GraduationHat01Icon, HomeLineIcon } from '@systemeio/icons'
import type { ParseKeys } from 'i18next'
import type { UnauthorizedUser, UserInterface } from 'shared/types/user-interface'
import { getDashboardLink, getShowDashboardLink } from './utils'

export interface MenuItemConfigType {
  name: ParseKeys
  href: string | ((user: UnauthorizedUser | UserInterface) => string)
  icon: ReactNode
  shouldItemRender?: (user: UnauthorizedUser | UserInterface) => boolean
  dataTestId?: string
}

export const menuItemsConfig: MenuItemConfigType[] = [
  {
    name: 'header.nav.communities',
    href: '/community',
    icon: <Users01Icon className="size-6" />,
    dataTestId: 'header-nav-communities-button',
  },
  {
    name: 'header.nav.courses',
    href: '/school',
    icon: <GraduationHat01Icon className="size-6" />,
    dataTestId: 'header-nav-courses-button',
  },
  {
    name: 'header.nav.dashboard',
    href: user => getDashboardLink(user),
    icon: <HomeLineIcon className="size-6" />,
    shouldItemRender: user => getShowDashboardLink(user),
    dataTestId: 'header-nav-dashboard-button',
  },
]
